import { FC } from 'react'

import {
  Button,
  ButtonColors,
  ButtonSizes,
  ButtonVariants
} from '@inno-ui/button'
import { RocketLineIcon, TriangleRightLineIcon } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './FeatureCard.module.scss'
import { FeatureCardProps } from './FeatureCard.types'

export const FeatureCard: FC<FeatureCardProps> = ({
  title,
  featureName,
  heading,
  description,
  iconPath,
  videoPath,
  onTourClick,
  onTellMeMoreClick
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'discover_apps'
  })

  return (
    <article className={styles.card}>
      {/* Top: Icon + Title/FeatureName left, Tour button right */}
      <header className={styles.topSection}>
        <div className={styles.leftContent}>
          {iconPath && (
            <img src={iconPath} alt={title} className={styles.icon} />
          )}
          <div className={styles.titleSection}>
            <h3 className={styles.title}>{title}</h3>
            <h4 className={styles.featureName}>{featureName}</h4>
          </div>
        </div>
        <div className={styles.tourButton}>
          <Button
            size={ButtonSizes.M}
            variant={ButtonVariants.Dark}
            color={ButtonColors.Green}
            label={t('buttons.tour')}
            icon={RocketLineIcon}
            onClick={onTourClick}
          />
        </div>
      </header>

      {/* Middle: Heading + Description and Video in same row */}
      <section className={styles.middleSection}>
        <div className={styles.descriptionSection}>
          <h5 className={styles.heading}>{heading}</h5>
          <p className={styles.description}>{description}</p>
        </div>
        <aside className={styles.videoContainer}>
          <video
            src={videoPath}
            autoPlay
            loop
            muted
            playsInline
            className={styles.video}
          />
          <div className={styles.videoShadow} />
          <div className={styles.tellMeMoreButton}>
            <Button
              size={ButtonSizes.M}
              variant={ButtonVariants.Dark}
              color={ButtonColors.Blue}
              label={t('buttons.tell_me_more')}
              icon={TriangleRightLineIcon}
              onClick={onTellMeMoreClick}
            />
          </div>
        </aside>
      </section>
    </article>
  )
}
